import React, { useEffect } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { Link, Button, Icon } from '@resy/ui-kitchen';
import { CTA_EVENT_NAME } from '../../../AmexMarketingUtils/constants';
import { handleMktAnalytics } from '../../../AmexMarketingUtils/AmexUtils';
import Times from '../../../../images/amexrga/times.svg';
import './SideDrawer.scss';

const SideDrawer = ({
  menuItems,
  show,
  drawerClickHandler,
  mobileMenuContent,
  onAfterOpen,
  onAfterClose,
  baseRequestUrl,
  logo,
  logoAria,
  mobileFooterLogo,
  mobileFooterLogoAria,
  mobileFooterLogoHeadline,
  displayMenuItems,
  Analytics,
}) => {
  const updatedMobileMenuContent = mobileMenuContent.map((item) => ({ ...item, external: true }));

  const handleClose = () => {
    onAfterClose();
    drawerClickHandler();
  };

  const handleOnKeyPress = (event) => {
    if (event.key === 'Escape') {
      handleClose();
    }
  };

  useEffect(() => {
    if (show) {
      onAfterOpen('.SideDrawer');
    }
  });

  const displayCTA = (cta) => {
    const {
      label, url, name, external,
    } = cta;
    if (!label || displayMenuItems[name] === false) return null;

    return (
      <li key={label}>
        <Link
          href={url}
          className={`${external ? 'SideDrawer__resy-link' : 'SideDrawer__link'}`}
          {...(external ? {} : { onKeyDown: { handleOnKeyPress } })}
          onClick={() => {
            handleClose();
            document.removeEventListener('keyup', handleOnKeyPress);
            const extraParam = {
              action_name: 'Menu - Click',
              item_name: label,
            };
            handleMktAnalytics(Analytics.event, CTA_EVENT_NAME, extraParam);
          }}
        >
          {label}
        </Link>
      </li>
    );
  };

  return (
    <div
      className={cx('SideDrawer', {
        open: show,
      })}
      id="sideDrawer"
      hidden={!show}
    >
      <div className="SideDrawer__logo">
        <Button
          variant="no-style"
          type="button"
          className="SideDrawer__toggle-button"
          onClick={handleClose}
          aria-label="Close mobile navigation"
        >
          <Times />
        </Button>
        {logo && (
          <img
            className="SideDrawer__logo-drawer"
            alt={logoAria}
            src={`${baseRequestUrl}AmexGDAB2B/logos/${logo}`}
          />
        )}
      </div>
      <nav aria-label="Main mobile navigation">
        <ul>
          {menuItems?.map((item) => (
            displayCTA(item)
          ))}
        </ul>
        <hr role="presentation" />
        <ul>
          {updatedMobileMenuContent.map((link) => (
            displayCTA(link)
          ))}
        </ul>
      </nav>
      {(mobileFooterLogo && mobileFooterLogoHeadline) && (
        <div className="SideDrawer__Amex">
          <p className="SideDrawer__Amex--headline">{mobileFooterLogoHeadline}</p>
          <p>
            <span aria-hidden="true">
              <Icon
                url={`${baseRequestUrl}AmexGDAB2B/logos/${mobileFooterLogo}`}
              />
            </span>
            <span className="sr-only">{mobileFooterLogoAria}</span>
          </p>
        </div>
      )}
    </div>
  );
};

SideDrawer.propTypes = {
  menuItems: PropTypes.arrayOf(PropTypes.object).isRequired,
  show: PropTypes.bool.isRequired,
  drawerClickHandler: PropTypes.func.isRequired,
  mobileMenuContent: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onAfterClose: PropTypes.func.isRequired,
  onAfterOpen: PropTypes.func.isRequired,
  baseRequestUrl: PropTypes.string.isRequired,
  logo: PropTypes.string.isRequired,
  logoAria: PropTypes.string.isRequired,
  mobileFooterLogo: PropTypes.string.isRequired,
  mobileFooterLogoAria: PropTypes.string.isRequired,
  mobileFooterLogoHeadline: PropTypes.string.isRequired,
  hideAboutProgram: PropTypes.bool.isRequired,
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
  displayMenuItems: PropTypes.shape({}).isRequired,
};

export default SideDrawer;
